import { Button } from 'antd';
import React, { useState } from 'react';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { ColoredSquare, Line, SpanRight } from './ThresholdDatabilityRelationLine.style';
import { Threshold } from './ThresholdEditor';

interface ThresholdDatabilityRelationLineProps {
    threshold: Threshold;
    appearance: { backgroundColor: string; label: string };
    onEdit(e: React.MouseEvent<HTMLElement, MouseEvent>): void;
    onDelete(e: React.MouseEvent<HTMLElement, MouseEvent>): void;
    inActive: boolean;
}

const ThresholdDatabilityRelationLine: React.FC<ThresholdDatabilityRelationLineProps> = ({ threshold, appearance, onEdit, onDelete, inActive }) => {
    const [isLineHovered, setLineHovered] = useState(false);

    return (
        <Line inActive={inActive} onMouseOver={() => setLineHovered(true)} onMouseLeave={() => setLineHovered(false)}>
            <strong>
                {threshold.operator} {threshold.value}
            </strong>{' '}
            then <ColoredSquare inActive={inActive} color={appearance.backgroundColor} /> <strong>{appearance.label}</strong>
            {isLineHovered && (
                <SpanRight>
                    <Button size='small' icon={<EditOutlined />} shape='circle' onClick={onEdit} />
                    <Button size='small' icon={<DeleteOutlined />} shape='circle' onClick={onDelete} />
                </SpanRight>
            )}
        </Line>
    );
};

export default ThresholdDatabilityRelationLine;
